<template>
  <div class="main-content">
    <div class="row">
      <div class="col-md-12">
        <div class="card">
          <div class="card-body">
            <!-- Cabeçalho -->
            <div class="d-flex align-items-center justify-content-between mb-4">
              <h4 class="mb-0">
                <i class="fas fa-code-branch text-primary mr-2"></i>
                {{ isEdit ? "Editar Release" : "Nova Release" }}
                <small class="text-muted ml-2" v-if="project.name"
                  >— {{ project.name }}</small
                >
              </h4>
              <button class="btn btn-secondary" @click="$router.back()">
                <i class="fas fa-arrow-left mr-1"></i> Voltar
              </button>
            </div>

            <form @submit.prevent="save">
              <!-- Linha 1: Nome + Versão + Status -->
              <div class="row">
                <div class="col-md-5">
                  <div class="form-group">
                    <label
                      >Nome da Release <span class="text-danger">*</span></label
                    >
                    <input
                      type="text"
                      class="form-control"
                      v-model="release.name"
                      placeholder="Ex.: Sprint 12 – Ajustes de Aprovação"
                      required
                    />
                  </div>
                </div>

                <div class="col-md-3">
                  <div class="form-group">
                    <label
                      >Versão (Maior . Menor . Patch)
                      <span class="text-danger">*</span></label
                    >
                    <div class="d-flex">
                      <input
                        type="number"
                        class="form-control text-center mr-1"
                        v-model.number="release.major"
                        min="0"
                        style="width: 60px"
                        placeholder="1"
                      />
                      <span class="align-self-center font-weight-bold">.</span>
                      <input
                        type="number"
                        class="form-control text-center mx-1"
                        v-model.number="release.minor"
                        min="0"
                        style="width: 60px"
                        placeholder="0"
                      />
                      <span class="align-self-center font-weight-bold">.</span>
                      <input
                        type="number"
                        class="form-control text-center ml-1"
                        v-model.number="release.patch"
                        min="0"
                        style="width: 60px"
                        placeholder="0"
                      />
                    </div>
                  </div>
                </div>

                <div class="col-md-4">
                  <div class="form-group">
                    <label>Status <span class="text-danger">*</span></label>
                    <v-select
                      v-model="release.status"
                      :options="statusOptions"
                      :reduce="(s) => s.value"
                      label="label"
                    ></v-select>
                  </div>
                </div>
              </div>

              <!-- Linha 2: Datas (row 1) -->
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Data Fim do Desenvolvimento</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="release.data_fim_desenvolvimento"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Data Prevista Início dos Testes</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="release.data_prevista_inicio_testes"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Data Fim dos Testes</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="release.data_fim_testes"
                    />
                  </div>
                </div>
              </div>

              <!-- Linha 3: Datas (row 2) -->
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Programação Inicial de Deploy</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="release.programacao_inicial_deploy"
                    />
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Data Fechamento da Release</label>
                    <input
                      type="date"
                      class="form-control"
                      v-model="release.data_fechamento_release"
                    />
                  </div>
                </div>
              </div>

              <hr />

              <!-- Linha 4: Pessoas -->
              <div class="row">
                <div class="col-md-4">
                  <div class="form-group">
                    <label>Relator da Versão</label>
                    <v-select
                      v-model="release.relator_id"
                      :options="users"
                      :reduce="(u) => u.id"
                      label="name"
                      placeholder="Selecione..."
                    ></v-select>
                  </div>
                </div>
                <div class="col-md-4">
                  <div class="form-group">
                    <label>P.O (Product Owner)</label>
                    <v-select
                      v-model="release.po_id"
                      :options="users"
                      :reduce="(u) => u.id"
                      label="name"
                      placeholder="Selecione..."
                    ></v-select>
                  </div>
                </div>
              </div>

              <div class="row">
                <div class="col-md-6">
                  <div class="form-group">
                    <label>QA (pode selecionar vários)</label>
                    <v-select
                      v-model="release.qa_ids"
                      :options="users"
                      :reduce="(u) => u.id"
                      label="name"
                      multiple
                      placeholder="Selecione os QAs..."
                    ></v-select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="form-group">
                    <label
                      >Desenvolvedores Envolvidos (pode selecionar
                      vários)</label
                    >
                    <v-select
                      v-model="release.dev_ids"
                      :options="users"
                      :reduce="(u) => u.id"
                      label="name"
                      multiple
                      placeholder="Selecione os devs..."
                    ></v-select>
                  </div>
                </div>
              </div>

              <!-- Observações -->
              <div class="row">
                <div class="col-md-12">
                  <div class="form-group">
                    <label>Observações</label>
                    <textarea
                      class="form-control"
                      rows="3"
                      v-model="release.description"
                      placeholder="Notas adicionais..."
                    ></textarea>
                  </div>
                </div>
              </div>

              <!-- Botões -->
              <div class="row mt-3">
                <div class="col-md-12 d-flex justify-content-end">
                  <button
                    type="button"
                    class="btn btn-secondary mr-2"
                    @click="$router.back()"
                  >
                    Cancelar
                  </button>
                  <button
                    type="submit"
                    class="btn btn-primary"
                    :disabled="saving"
                  >
                    <i class="fas fa-save mr-1"></i>
                    {{ saving ? "Salvando..." : "Salvar Release" }}
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      release: {
        name: "",
        major: 1,
        minor: 0,
        patch: 0,
        status: "planejada",
        description: "",
        data_fim_desenvolvimento: null,
        data_prevista_inicio_testes: null,
        data_fim_testes: null,
        programacao_inicial_deploy: null,
        data_fechamento_release: null,
        relator_id: null,
        po_id: null,
        qa_ids: [],
        dev_ids: [],
      },
      users: [],
      project: {},
      saving: false,
      statusOptions: [
        { value: "planejada", label: "Planejada" },
        { value: "em_desenvolvimento", label: "Em Desenvolvimento" },
        { value: "em_testes", label: "Em Testes" },
        { value: "fechada", label: "Fechada" },
        { value: "finalizada", label: "Finalizada" },
      ],
    };
  },

  computed: {
    projectId() {
      return this.$route.params.project_id;
    },
    releaseId() {
      return this.$route.params.id;
    },
    isEdit() {
      return !!this.releaseId;
    },
  },

  mounted() {
    this.getUsers();
    this.getProject();
    if (this.isEdit) {
      this.getRelease();
    } else {
      this.getNextVersion();
    }
  },

  methods: {
    getNextVersion() {
      axios
        .get(this.$store.state.api + `releases/next-version/${this.projectId}`)
        .then((res) => {
          this.release.major = res.data.major;
          this.release.minor = res.data.minor;
          this.release.patch = res.data.patch;
        })
        .catch(() => {});
    },

    getProject() {
      axios
        .get(this.$store.state.api + `projects/${this.projectId}`)
        .then((res) => {
          this.project = res.data;
        })
        .catch(() => {});
    },

    getUsers() {
      axios
        .get(this.$store.state.api + "users?paginated=false")
        .then((res) => {
          this.users = res.data.data || res.data;
        })
        .catch(() => {});
    },

    getRelease() {
      axios
        .get(
          this.$store.state.api +
            `releases/${this.releaseId}?with[]=qaUsers&with[]=devUsers&with[]=relator&with[]=po`
        )
        .then((res) => {
          const r = res.data;
          this.release = {
            ...r,
            qa_ids: (r.qa_users || []).map((u) => u.id),
            dev_ids: (r.dev_users || []).map((u) => u.id),
          };
        })
        .catch(() => {
          this.$message(
            "Erro",
            "Não foi possível carregar a release.",
            "error"
          );
        });
    },

    save() {
      if (!this.release.name || !this.projectId) {
        this.$message("Atenção", "Nome e sistema são obrigatórios.", "warning");
        return;
      }

      this.saving = true;
      const payload = { ...this.release, project_id: this.projectId };
      const api = this.$store.state.api;
      const request = this.isEdit
        ? axios.put(api + `releases/${this.releaseId}`, payload)
        : axios.post(api + "releases", payload);

      request
        .then((res) => {
          this.$message("Sucesso", "Release salva com sucesso!", "success");
          this.$router.push(`/projects/${this.projectId}/releases`);
        })
        .catch((err) => {
          const msg = err.response?.data?.message || "Erro ao salvar release.";
          this.$message("Erro", msg, "error");
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>
